import { IListarCasoRequest } from "../../../Interfaces/Vendas/Caso/CasoInterface";
import {
    IContactListItem,
    ILeadRequest,
    ILeadTagRequest,
} from "../../../Interfaces/Vendas/Lead/LeadInterface";
import {
    TransferirLeadsEmMassaService,
    VendasDeletarTagService,
    VendasInserirContatoService,
    VendasInserirTagsService,
    VendasLeadGetService,
    VendasLeadPostService,
    VendasLeadPutService,
    VendasListarContatosService,
    VendasListarTagsService,
} from "../../../Services/Vendas/Lead/LeadService";
import { Controller } from "../../Controller";

export async function VendasLeadPostController(requestBody: ILeadRequest) {
    return Controller(VendasLeadPostService(requestBody));
}

export async function VendasLeadGetController(idLead: number) {
    return Controller(VendasLeadGetService(idLead));
}

export async function VendasLeadPutController(requestBody: ILeadRequest) {
    return Controller(VendasLeadPutService(requestBody));
}

export async function VendasListarTagsController(idLead: number) {
    return Controller(VendasListarTagsService(idLead));
}

export async function VendasInserirTagsController(
    requestBody: ILeadTagRequest
) {
    return Controller(VendasInserirTagsService(requestBody));
}

export async function VendasDeletarTagController(
    idLead: number,
    dsTag: string
) {
    return Controller(VendasDeletarTagService(idLead, dsTag));
}

export async function VendasListarContatosController(idLead: number) {
    return Controller(VendasListarContatosService(idLead));
}

export async function VendasInserirContatoController(
    requestBody: IContactListItem
) {
    return Controller(VendasInserirContatoService(requestBody));
}

export async function TransferirLeadsEmMassaController(
    ID_RESPONSAVEL_DESTINO: number,
    requestBody: IListarCasoRequest
) {
    return Controller(
        TransferirLeadsEmMassaService(ID_RESPONSAVEL_DESTINO, requestBody)
    );
}
